import { auth } from "../firebaseClient.js";

async function getAuthHeaders() {
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error("Aktif oturum bulunamadı.");
  }

  const idToken = await currentUser.getIdToken();

  return {
    Authorization: `Bearer ${idToken}`
  };
}

async function parseJsonResponse(response) {
  const rawText = await response.text();

  let data = null;

  try {
    data = rawText ? JSON.parse(rawText) : null;
  } catch {
    throw new Error(`API JSON yerine şunu döndürdü: ${rawText}`);
  }

  if (!response.ok) {
    throw new Error(
      data?.error || data?.message || `İstek başarısız. HTTP ${response.status}`
    );
  }

  return data;
}

export async function importUsersFromFile(file) {
  if (!file) {
    throw new Error("Dosya seçilmedi.");
  }

  const headers = await getAuthHeaders();

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch("/api/import-users", {
    method: "POST",
    headers,
    body: formData
  });

  return await parseJsonResponse(response);
}

export async function getSchoolsForDropdown() {
  const headers = await getAuthHeaders();

  const response = await fetch("/api/schools", {
    method: "GET",
    headers
  });

  return await parseJsonResponse(response);
}

export async function findStudentBySchoolAndNumber(schoolCode, studentNumber) {
  if (!schoolCode) {
    throw new Error("schoolCode zorunlu.");
  }

  if (!studentNumber) {
    throw new Error("studentNumber zorunlu.");
  }

  const headers = await getAuthHeaders();

  const response = await fetch(
    `/api/student-by-school-and-number?schoolCode=${encodeURIComponent(
      schoolCode
    )}&studentNumber=${encodeURIComponent(studentNumber)}`,
    {
      method: "GET",
      headers
    }
  );

  return await parseJsonResponse(response);
}

export async function updateStudentByUid(uid, payload) {
  if (!uid) {
    throw new Error("uid zorunlu.");
  }

  const headers = await getAuthHeaders();

  const response = await fetch(`/api/students/${uid}`, {
    method: "PATCH",
    headers: {
      ...headers,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  return await parseJsonResponse(response);
}
export async function importLearningOutcomesFromFile(file) {
  if (!file) {
    throw new Error("Dosya seçilmedi.");
  }

  const headers = await getAuthHeaders();

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch("/api/import-learning-outcomes", {
    method: "POST",
    headers,
    body: formData
  });

  return await parseJsonResponse(response);
}